import {
    GET_CONFIG_FORM18, 
    GET_GRILLA_BUSQUEDA
   
} from '../types';
export default function trazabilidadReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM18:
            return { ...state, cfg_form18:action.payload }
       
        case GET_GRILLA_BUSQUEDA:
            return { ...state, respuestaGrillaBusqueda:action.payload }
       
       
       
       
        default:
            return state
    }
}